module.exports = __webpack_public_path__ + "media/images/icons/twotone/right-circle-80f0040dd10d46ea8aec43bff0f5d1c1.svg";